/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useState } from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { useDispatch, useSelector } from 'react-redux';
import { canEditItemForItem, getId } from '../../utils/item';
import { NumGlobal } from './num.Global';
import { setOpenModales } from '../../store/global';

export const NumSortable = props => {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id: props.id });
  const { numId, itemId } = props;

  const item = useSelector(state => state.items[itemId]);
  const items = useSelector(state => state.items);
  const dispatch = useDispatch();
  const [num, setNum] = useState(null);
  const canEdit = canEditItemForItem(item, items);
  const modalId = `numSettings:${itemId}:${numId}`;

  useEffect(() => {
    if (item?.has_num) {
      const numObj = item.has_num.find(entry => getId(entry) === numId);
      if (numObj?.[numId]) {
        setNum(numObj[numId]);
      }
    }
  }, [item?.has_num, numId]);

  const fieldInGrid = useMemo(() => {
    return {
      type: 'num',
      displayType: num?.display ?? 'big',
    };
  }, [num]);

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  if (!num) {
    return null;
  }

  return (
    <div
      ref={setNodeRef}
      {...attributes}
      {...listeners}
      style={style}
      className='m-1 flex flex-col justify-center items-center'
      onDoubleClick={e => {
        e.stopPropagation();
        if (canEdit) {
          dispatch(setOpenModales({ id: modalId, open: true }));
        }
      }}
    >
      <NumGlobal
        numId={numId}
        itemId={itemId}
        num={num}
        fieldInGrid={fieldInGrid}
        canEdit={canEdit}
      />
    </div>
  );
};
